import { render } from "./MediaflowDockEmpty.vue?vue&type=template&id=1f338856"
import script from "./MediaflowDockEmpty.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaflowDockEmpty.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Mediaflow/MediaflowDockEmpty.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1f338856"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1f338856', __exports__)) {
    api.reload('1f338856', __exports__)
  }
  
  module.hot.accept("./MediaflowDockEmpty.vue?vue&type=template&id=1f338856", () => {
    api.rerender('1f338856', render)
  })

}


export default __exports__